import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import * as lodash from 'lodash'
import { selectAllUsers, User, userFullname } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-document-user-notifications',
  templateUrl: './document-user-notifications.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DocumentUserNotificationsComponent {
  @Input() form: UntypedFormGroup
  @Input() receiverForm: UntypedFormGroup

  users$ = this.store.pipe(select(selectAllUsers))
  constructor(private store: Store<any>) {}

  onUserSelect(users: User[]) {
    const user = lodash.head(users)
    this.receiverForm.patchValue({ email: user?.primaryEmail, name: userFullname(user) }, { emitEvent: false })
  }
}
